//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DexBuilder.js";
let d=[[[0,"FacetBodyType",1,0],[0,"FileName",1,0],[0,"MoveFacetBodytoWCSOrigin",1,0],[0,"SourceUnits",1,0],[0,"SpecifyCsys",1,"CoordinateSystem",0]],[],[]];
SPLM.GeospatialDataImporter = class extends SPLM.DexBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeospatialDataImporter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeospatialDataImporter.BodyType = Object.freeze({
    "Convergent" : "Convergent", "Nx" : "Nx"});

SPLM.GeospatialDataImporter.Units = Object.freeze({
    "Millimeter" : "Millimeter", "Centimeter" : "Centimeter", "Meter" : "Meter", "Kilometer" : "Kilometer", "Inch" : "Inch", "Foot" : "Foot", "UsSurveyFoot" : "UsSurveyFoot", "Mile" : "Mile"});

export default SPLM;